import { render, staticRenderFns } from "./Mri202407View.vue?vue&type=template&id=02190d78&scoped=true&"
import script from "./Mri202407View.vue?vue&type=script&lang=js&"
export * from "./Mri202407View.vue?vue&type=script&lang=js&"
import style0 from "./Mri202407View.vue?vue&type=style&index=0&id=02190d78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02190d78",
  null
  
)

export default component.exports